import React from 'react';
import {FormattedMessage} from "react-intl";

// Assets
import {greyishBlue50, red500} from "assets/jss/main";

function CancelledTitle(props) {
    return (
        <div style={{
            color: red500,
            fontWeight: 600,
            fontSize: 16,
            padding: '24px 16px',
            borderBottom: `1px solid ${greyishBlue50}`
        }}>
            <FormattedMessage id='wms.myPickingMissions.product.cancelled.products' />
        </div>
    );
}

export default CancelledTitle;
